import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

/* -------------------- THUNKS -------------------- */

// Categories
export const loadCategoryData = createAsyncThunk(
  "forum/loadCategoryData",
  async (_, { rejectWithValue }) => {
    try {
      const res = await agent.get(API.FORUM_CATEGORY);
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

// Forums (questions)
export const loadForumData = createAsyncThunk(
  "forum/loadForumData",
  async (userId, { rejectWithValue }) => {
    try {
      const res = await agent.get(`${API.FORUM_DATA_FETCH}/${userId}`);
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

// Save forum user
export const saveForumUser = createAsyncThunk(
  "forum/saveForumUser",
  async (userId, { rejectWithValue }) => {
    try {
      await agent.post(API.FORUM_USER_SET, userId); // ✅ FIX
      return true;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


// Forum users
export const loadForumUserData = createAsyncThunk(
  "forum/loadForumUserData",
  async (roleId, { rejectWithValue }) => {
    try {
      const res = await agent.get(`${API.FORUM_USER_GET}/${roleId}`);
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

// Like answer
export const saveForumAnswerLike = createAsyncThunk(
  "forum/saveForumAnswerLike",
  async (params, { rejectWithValue }) => {
    try {
      const res = await agent.post(API.FORUM_ANS_LIKE_SET, params);
      return res.data?.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

/* -------------------- SLICE -------------------- */

const forumSlice = createSlice({
  name: "forum",
  initialState: {
    categories: [],
    forums: [],
    forumusers: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadCategoryData.fulfilled, (state, action) => {
        state.categories = action.payload;
      })
      .addCase(loadForumData.fulfilled, (state, action) => {
        state.forums = action.payload;
      })
      .addCase(loadForumUserData.fulfilled, (state, action) => {
        state.forumusers = action.payload;
      })
      .addCase(saveForumAnswerLike.fulfilled, (state, action) => {
        state.forums = action.payload;
      });
  },
});

export default forumSlice.reducer;
